import { Storage } from 'aws-amplify'
import config from '../config'
import moment from 'moment'
import { Buffer } from 'buffer'

let application

/**
 * S3情報の型定義
 * @typedef {Object} S3
 * @property {string} key s3_key
 */

/**
 * Fileをアップロードする
 * @param {string} dir ディレクトリパス
 * @param {File} file ファイル
 * @returns {Promise<S3>} 保存先のS3情報
 */
const put = async (dir, file) => {
  return await Storage.put(createKey(dir, file.name), file, {
    contentType: file.type})
}

const putApp = (id, file) => {
  return put(createFolderName(id), file)
}

const putFirmware = (file) => {
  return put(createFirmwareFolderName(), file)
}

/**
 * 暗号化キー保存
 * @param {File} file キー
 * @returns {Promise<S3>} S3保存情報
 */
const putCryptKey = async (file) => {
  return await Storage.put(createCryptKeyFolderName() + file.name, file, {contentType: file.type})
}

/**
 * 暗号化キー取得
 * @param {File} file キー
 * @returns {Promise<string>} キー
 */
const getCryptKey = async (key) => {
  const fullKey = getCryptoKeyPath(key)
  // ファイル名は暗号化キーとする（スラッシュはハイフンに変換する）
  const result = await get(fullKey, { download: true })
  return Buffer.from(result.Body).toString()
}

const getCryptoKeyPath = (key) => {
  return createCryptKeyFolderName() + key + '.key'
}

// upload済み画像を表示するための URLを取得
const get = async (key, options = {}) => {
  return await Storage.get(key, Object.assign({ expires: 3600 }, options))
}

const download = async (key) => {
  return await Storage.get(key, { expires: 3600, download: true })
}

const remove = async (key) => {
  return await Storage.remove(key)
}

const list = async (id) => {
  return await Storage.list(createFolderName(id))
}

const createFolderName = (id) => {
  if(!application) throw Error('no application')
  return config.getStage() + '/' + application + '/' + id +'/'
}

const createFirmwareFolderName = () => {
  return config.getStage() + '/firmware/'
}

const createCryptKeyFolderName = () => {
  return config.getStage() + '/cipher-key/'
}

const createKey = (dir, fileName) => {
  return dir + moment().format('YYYYMMDDhhmmss')+ '_' + fileName
}

const setApplication = (_application) =>{
  application = _application
}


export default {
  putApp,
  putFirmware,
  putCryptKey,
  getCryptKey,
  getCryptoKeyPath,
  get,
  download,
  remove,
  list,
  setApplication
}
